import type { FaireProductEntity } from "../../entity_types/product";

export const p_z9tsvnn9s4: FaireProductEntity = {
  token: "p_z9tsvnn9s4",
  type: "product",
  name: "Many Hearts Thanks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/8b118c8763f30b8c53c62db450f086388c059fc78de4a93f2a34219a295df9e1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7899f94814b7d9ad5b10dca8a952f6aae6982f311e18270b9e569ef1754b0338.jpeg"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:17.736Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
